import { ArrowUpRight } from "lucide-react";
import Link from "next/link";

export default function AboutCompany() {
  return (
    // Reduced top gap using -mt-6 (mobile) and -mt-8 (tablet+)
    <div className="relative -mt-6 sm:-mt-8 grid grid-cols-1 items-center gap-10 lg:gap-16 md:grid-cols-2">
      {/* Left side content */}
      <div className="min-w-0">
        <div className="inline-flex items-center rounded-[30px] border border-black px-[18px] py-[8px] text-[14px] sm:text-[15px] font-semibold mb-5 sm:mb-6">
          About Company
        </div>

        <h3
          className="
            text-[22px] sm:text-[28px] md:text-[38px] lg:text-[42px]
            leading-[1.25] tracking-[-0.015em]
             font-sans
          "
          style={{ color: "#333333" }}
        >
          Your Global Partner in Precision Manufacturing
        </h3>

        <p
          className="
            mt-4 sm:mt-5 
            text-[14px] sm:text-[15px] md:text-[16px]
            leading-[1.65] font-sans
          "
          style={{ fontWeight: 400, color: "#555555" }}
        >
          MMI supports component, assembly and complete product manufacturing across industrial and heavy-engineering sectors, including electric power, commercial vehicles, construction equipment, mining, oil and gas, and general industrial machinery. Capabilities include design-for-manufacture support, prototyping, production, machining, and assembly. Our manufacturing is executed through approved production wholly owned facilities in India, with supplier coordination and warehousing in China, Vietnam, and South Korea. Our operations cover sourcing, process control, inspection, and delivery to customer drawings and specifications.
        </p>

        {/* Desktop button only */}
        <Link
          href="/about"
          className="hidden md:inline-flex mt-7 items-center rounded-[30px] bg-[#FDC300] px-[18px] py-[9px] text-[14px] font-semibold text-black shadow-sm hover:brightness-95 transition-all"
        >
          Learn More
          <ArrowUpRight className="ml-2 h-4 w-4" />
        </Link>
      </div>

      {/* Right side image with mobile button overlay */}
      <div className="relative min-w-0 flex justify-center">
        <img
          src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/2.png-fyRWHSWHUhJNCrWkR0docMpQ1smux9.jpeg"
          alt="Precision manufacturing process - welding and fabrication"
          className="w-full max-w-[400px] h-auto aspect-[3/4] rounded-[20px] object-cover shadow-[0_4px_12px_rgba(0,0,0,0.08)]"
        />

        {/* Mobile button (absolute inside image) */}
        <Link
          href="/about"
          className="md:hidden absolute bottom-4 left-4 inline-flex items-center rounded-[30px] bg-[#FDC300] px-[18px] py-[9px] text-[14px] font-semibold text-black shadow-sm hover:brightness-95 transition-all"
        >
          Learn More
          <ArrowUpRight className="ml-2 h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
